export const FormExplanationSection: React.FC<{
  explanation: React.ReactNode;
}> = ({ explanation }) => {
  return (
    <div className="flex flex-wrap p-8 bg-[#F4F0E5] font-medium">
      {explanation}
    </div>
  );
};
